import type { RewardType } from '@cou/admin-ui';

/**
 * A payout-matrix cell (GL-14): reward type plus its adapter-specific value fields. Shared
 * between the detail page's read-only Prizes tab and the editor's payout-matrix editor
 * (CAE-298), so both render the same reward summary from the same stored shape.
 */
export interface RewardCell {
  readonly type: string;
  readonly amount?: number;
  readonly value?: number;
  readonly maxStake?: number;
}

/** The stored `type` string ('FreeBet' etc.) as admin-ui's `RewardPill` spells it. `raw` is
 * declared `unknown`, not `string`: the value comes from a jsonb column the backend only
 * validates as "an object" (CAE-298), so a cell missing `type` must not throw during render. */
export function toRewardType(raw: unknown): RewardType | null {
  if (typeof raw !== 'string') return null;
  const key = raw.toLowerCase().replace(/[\s_-]/g, '');
  if (key === 'freebet' || key === 'bonusbet') return 'freebet';
  if (key === 'profitboost') return 'profitboost';
  if (key === 'parlay' || key === 'parlayescalator') return 'parlay';
  return null;
}

export function formatRewardValue(cell: RewardCell): string {
  if (cell.amount != null) return `$${cell.amount}`;
  if (cell.value != null) {
    const capped = cell.maxStake != null ? ` · max $${cell.maxStake}` : '';
    return `${cell.value}%${capped}`;
  }
  return '';
}
